/**
 * Empty sandbox template.
 * 
 * A minimal starting point with just the basic structure:
 * - shared/constants.ts with empty SYSTEMS and MESSAGES enums
 * 
 * Perfect for starting from scratch or learning the Gotti framework structure.
 */

// Import empty template files as raw strings
import sharedConstantsCode from '../../templates/sandbox-empty/shared/constants.ts?raw';
import { SandboxTemplate } from './types';


export const emptyTemplate: SandboxTemplate = {
  name: 'Empty',
  description: 'A blank canvas with minimal boilerplate - just constants and API types.',
  systems: {
    shared: {
      rootFiles: [
        { name: 'constants', code: sharedConstantsCode },
      ],
      subfolders: {
        components: [],
        entities: [],
      },
    },
    client: {
      rootFiles: [],
      subfolders: {
        systems: [],
        components: [],
        entities: [],
      },
    },
    server: {
      rootFiles: [],
      subfolders: {
        systems: [],
        components: [],
        entities: [],
      },
    },
  }
};
